// @flow

import moment from 'moment';

import ApiObject from '../ApiObject';

import DeliveryAdaptableTimeSettings from './DeliveryAdaptableTimeSettings';
import DeliveryFixTimeSettings from './DeliveryFixTimeSettings';

export default class DeliveryTimeSettings extends ApiObject {

  static Type = {
    FIXED: 0,

    ADAPTABLE: 1,
  };

  settingsType: DeliveryTimeSettings.Type = DeliveryTimeSettings.Type.FIXED;

  adaptableTimeSettings: DeliveryAdaptableTimeSettings = new DeliveryAdaptableTimeSettings();

  fixTimeSettings: DeliveryFixTimeSettings = new DeliveryFixTimeSettings();

  postJsonAsssignation(data: Object) {
    this.adaptableTimeSettings = new DeliveryAdaptableTimeSettings().fromJson(data.adaptableTimeSettings);
    this.fixTimeSettings = new DeliveryFixTimeSettings().fromJson(data.fixTimeSettings);
	}
}
